import React, { FC } from 'react';
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom';
import { useAppInitialize } from './hooks/useAppInitialize';
import { useEmitPushHistory } from './hooks/useEmitPushHistory';
import { InitialLoading } from './pages/InitialLoading';
import { SubscriptionAddButton } from './pages/SubscriptionAddButton';
// import { ShippingAddressForm } from './pages/ShippingAddressForm';
// import { ShippingAddress } from './pages/ShippingAddress';
// import { PaymentMethodComplete } from './pages/PaymentMethodComplete';
// import { PaymentMethod } from './pages/PaymentMethod';
// import { SubscriptionCancelComplete } from './pages/SubscriptionCancelComplete';
// import { SubscriptionCancel } from './pages/SubscriptionCancel';
import { SubscriptionDetail } from './pages/SubscriptionDetail';

const History: FC<{ children: any }> = ({ children }) => {
  const pathname = useLocation().pathname;
  useEmitPushHistory(pathname);

  return children;
};

export const App = () => {
  const token = useAppInitialize();

  return Boolean(token) ? (
    <BrowserRouter basename="/?path=">
      <History>
        <Switch>
          <Route path="/subscription/add">
            <SubscriptionAddButton token={token} />
          </Route>
          {/*<Route path="/shippingAddress/form">
            <ShippingAddressForm token={token} />
          </Route>
          <Route path="/shippingAddress">
            <ShippingAddress token={token} />
          </Route>
          <Route path="/paymentMethod/complete">
            <PaymentMethodComplete token={token} />
          </Route>
          <Route path="/paymentMethod">
            <PaymentMethod token={token} />
          </Route>
          <Route path="/cancel/complete">
            <SubscriptionCancelComplete token={token} />
          </Route>
          <Route path="/cancel">
            <SubscriptionCancel token={token} />
          </Route>*/}
          <Route path="/">
            <SubscriptionDetail token={token} />
          </Route>
        </Switch>
      </History>
    </BrowserRouter>
  ) : (
    <InitialLoading/>
  );
};


/*
*/
